import { useFlags } from 'launchdarkly-react-client-sdk';
import Layout from '../../components/Layout';
import accessImg from './images/access-image@3x.jpg';
import './styles.scss';

const TrialUpgradeThanks = () => {
  const { chatbotAppliedLab: showChatbot } = useFlags();

  return (
    <Layout useMemorized={false} hideChatWidget={!showChatbot}>
      <section className="trial-upgrade-thanks" data-testid="trial-upgrade-thanks-container">
        <div className="trial-upgrade-thanks__text">
          <h2>
            Yay, You&apos;re a
            <br />
            FabFitFun Member!
          </h2>
          <p>
            You’re all set to enjoy the perks of being a FabFitFun member. You will receive an email
            confirming your subscription.
          </p>
          <a className="trial-upgrade-thanks__link fffBtnPrimary desktop" href="/">
            GO TO HOMEPAGE
          </a>
        </div>
        <div
          className="trial-upgrade-thanks__image"
          data-testid="trial-upgrade-thanks-image-container"
        >
          <img src={accessImg} alt="access" />
        </div>
        <a className="trial-upgrade-thanks__link fffBtnPrimary mobile" href="/">
          GO TO HOMEPAGE
        </a>
      </section>
    </Layout>
  );
};

export default TrialUpgradeThanks;
